export default "__VITE_ASSET__Uj1NyKjD__"